import { render, staticRenderFns } from "./LandingModal.vue?vue&type=template&id=37dc2f9e&"
import script from "./LandingModal.vue?vue&type=script&lang=js&"
export * from "./LandingModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports